// import React, { useState } from 'react';

// const ClinetSuggestion = ({ data, handleSuggestedClick }) => {
//   const [hoveredSuggestion, setHoveredSuggestion] = useState(null);
// console.log(data,'dataaa')
//   const handleChange = (client, e) => {
//     console.log(client,'client')
//     e.preventDefault(); 
//     handleSuggestedClick(client);
//   };

//   const ulStyle = {
//     listStyle: "none",
//     padding: 0,
//     margin: 0,
//     position: "absolute",
//     backgroundColor: "#fff",
//     border: "1px solid #ccc",
//     zIndex: 1000,
//     maxHeight: "300px",
//     overflowY: "auto",
//     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     width: "255px",
//   };

//   const liStyle = {
//     padding: "8px",
//     cursor: "pointer",
//   };

//   // CSS for customizing scrollbar in a React component
//   const scrollbarStyle = `
//     &::-webkit-scrollbar {
//       width: 5px;
//     }
//     &::-webkit-scrollbar-track {
//       background: #f1f1f1;
//     }
//     &::-webkit-scrollbar-thumb {
//       background: #888;
//     }
//     &::-webkit-scrollbar-thumb:hover {
//       background: #555;
//     }
//   `;

//   return (
//     <ul style={ulStyle} className="custom-scrollbar">
//       {data.map((client, index) => (
//         <li
//           key={index}
//           onClick={(e) => handleChange(client, e)}
//           style={{
//             ...liStyle,
//             ...(hoveredSuggestion === index ? { backgroundColor: '#6174DD', color: 'white' } : '')
//           }}
//           onMouseEnter={() => setHoveredSuggestion(index)}
//           onMouseLeave={() => setHoveredSuggestion(null)}
//         >
//           {`${client.clientName} (${client.clientNumber})`}
//         </li>
//       ))}
//       <style>
//         {`
//           .custom-scrollbar {
//             ${scrollbarStyle}
//           }
//         `}
//       </style>
//     </ul>
//   );
// };

// export default ClinetSuggestion;

import React, { useEffect, useRef, useState } from 'react';

const ClinetSuggestion = ({ data, handleSuggestedClick, focusedIndex, setFocusedIndex }) => {
  const [hoveredSuggestion, setHoveredSuggestion] = useState(null);
  const listRef = useRef(null);

  useEffect(() => {
    if (focusedIndex !== null && listRef.current) {
      const items = listRef.current.querySelectorAll('li');
      if (items[focusedIndex]) {
        items[focusedIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  }, [focusedIndex]);

  const handleChange = (client, e) => {
    e.preventDefault();
    handleSuggestedClick(client);
  };

  const ulStyle = {
    listStyle: "none",
    padding: 0,
    margin: 0,
    position: "absolute",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    zIndex: 1000,
    maxHeight: "300px",
    overflowY: "auto",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "255px",
  };

  const liStyle = {
    padding: "8px",
    cursor: "pointer",
  };

  return (
    <ul style={ulStyle} className="custom-scrollbar" ref={listRef}>
      {data.map((client, index) => (
        <li
          key={index}
          onClick={(e) => handleChange(client, e)}
          style={{
            ...liStyle,
             backgroundColor: hoveredSuggestion === index || focusedIndex === index 
              ? '#6174DD' 
              : 'white',
            color: hoveredSuggestion === index || focusedIndex === index 
              ? 'white' 
              : 'black'
          }}
          onMouseEnter={() => setHoveredSuggestion(index)}
          onMouseLeave={() => setHoveredSuggestion(null)}
        >
          {`${client.clientName} (${client.clientNumber})`}
        </li>
      ))}
      <style>
        {`
          .custom-scrollbar::-webkit-scrollbar {
            width: 5px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f1f1;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #888;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
        `}
      </style>
    </ul>
  );
};

export default ClinetSuggestion;

